import { push } from 'connected-react-router'
import { PATHS } from 'constants.js'
import { isRankingsPath } from 'rankings/selectors'
import { connect } from 'react-redux'
import { openSearch, selectors } from 'search'

import BottomMenu from './BottomMenu'

const mapStateToProps = state => ({
  isOpenSearch: selectors.isOpen(state),
  isRankingsPath: isRankingsPath(state),
})

const mapDispatchToProps = {
  onHome: () => push(PATHS.ROOT),
  onRankings: () => push(PATHS.RANKINGS),
  openSearch,
}

export default connect(mapStateToProps, mapDispatchToProps)(BottomMenu)
